import { mutatorAction } from 'satcheljs';
import type LocationPickerState from 'owa-location-common-well/lib/store/schema/LocationPickerState';
import getStore from '../store/store';

export const cacheLocationSuggestionsState = mutatorAction(
    'cacheLocationSuggestionsState',
    (state: Partial<LocationPickerState>) => {
        getStore().locationSuggestionsState = { ...getStore().locationSuggestionsState, ...state };
    }
);
